export default {
  brandColor1: '#FFEDC9',
  complimentaryColor1: '#0A6C32',
  brandColor2: '#0A6C32',
  complimentaryColor2: '#fff',
};
